// Types
import { ValidationRule } from '@/composables/useValidation'

export const PASSWORD_LENGTH = 8

export type UpdateFn = (
    key: keyof FormValues,
    value: string
) => void


export interface FormValues {
    currentPassword: string,
    newPassword: string,
    confirmPassword: string,
}

export interface ShowPasswords {
    current: boolean,
    new: boolean,
    confirm: boolean 
}

export type ValidationFields = Set<keyof FormValues>
export type ValidationRules = Record<keyof FormValues, ValidationRule<FormValues>>

export const validatePasswordLength = (value: string): boolean => value.length >= PASSWORD_LENGTH